// Styles
// **************************************
const closeButtonIcon = 'flex justify-center items-center w-5.5 h-5.5 text-ink/80 rounded-full group-hover:text-surface group-hover:bg-error bg-surface-100';
const addButtonIcon = 'flex justify-center items-center w-5.5 h-5.5 text-ink/80 rounded-full group-hover:text-surface group-hover:bg-primary bg-surface-100';
const suggestionButton = 'group flex items-center gap-1.5 py-1.5 px-3 rounded-full text-sm font-medium text-ink bg-surface-150 border border-transparent max-w-56 whitespace-nowrap transition-all duration-200 hover:border-secondary hover:bg-secondary hover:text-white hover:shadow-md';
const suggestionButtonIcon = 'shrink-0 text-secondary group-hover:text-white transition-all duration-200';
const suggestionTooltip = 'max-w-56 !leading-tight border -mt-0.5 !p-1 !px-2 !font-medium !shadow-none text-ink-medium';

const listboxOptionsWrapper = '!w-max !min-w-44 !max-h-96 pt-2 pb-1 overflow-y-auto scrollbar-thin mt-1 !rounded-md';
const listboxOptionBase = 'flex text-sm items-center pl-2.5 pr-3.5 py-1.5 gap-1.5';
const listboxOptionLink = 'cursor-pointer text-ink-medium data-focus:bg-surface-50 data-focus:text-ink data-selected:text-ink';
const listboxOption = `${listboxOptionBase} ${listboxOptionLink}`;
const listboxOptionCheck = 'w-5 h-5 text-ink/20 data-selected:text-primary';

const formFieldSpacing = 'mb-3 last:mb-0';
const formFieldLabel = 'py-0.5 text-ink-medium hover:text-ink has-[:checked]:text-ink';
const formFieldInput = 'text-primary cursor-pointer checked:bg-primary';

// Export
// **************************************
export const filterStyles = {
  closeButtonIcon,
  addButtonIcon,
  suggestionButton,
  suggestionButtonIcon,
  suggestionTooltip,
  listboxOptionsWrapper,
  listboxOption,
  listboxOptionBase,
  listboxOptionLink,
  listboxOptionCheck,
  formFieldSpacing,
  formFieldLabel,
  formFieldInput,
};
